/* eslint-disable prefer-destructuring */
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { compose } from 'redux';

import LoadingContainer from '../global/Loading';
import { withScrollingView } from '../../common/WithScrollingView';
import ProductAboveTheFoldContainer from '../shopping/ProductAboveTheFold';
import ProductBelowFold from '../shopping/ProductBelowFold';
import {
  setSelectedModifiers,
  setLastModifierSelection,
  setSelectedQty,
  setAddOnModifiers,
} from '../../store/actions/product.actions';
import {
  getProductDetails,
  getProductBreadcrumbs,
} from '../../store/selectors/product.selectors';
import { getUserDetails } from '../../store/selectors/user.selectors';
import { fetchReviewsAverageRating } from '../../store/actions/reviews.actions';

import Analytics from '../global/Analytics';

export const renderBreadcrumb = (breadcrumb) => breadcrumb && <Link to={`${breadcrumb.destinationPage && breadcrumb.destinationPage.url}${breadcrumb.anchor || ''}`}>{breadcrumb.text}</Link>;
export const renderBreadcrumbs = (breadcrumbs) => (
  <p className="pdp-breadcrumbs">
    {renderBreadcrumb(breadcrumbs.productPath)}{breadcrumbs.collectionPath ? ` ${<i className="icon icon-arrow-right" />} ${renderBreadcrumb(breadcrumbs.collectionPath)}` : ''}
  </p>
);

class Product extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    const {
      productDetails,
      userDetails,
    } = this.props;
    const {
      email = '',
    } = userDetails;
    try {
      Analytics.enqueue({
        method: 'item',
        params: {
          event: 'Product Viewed',
          item: productDetails,
          label: 'Product Page Viewed',
          email,
        },
        location: Analytics.getLocation(),
      });
    } catch (e) { /* nothing to do */ }
  }

  componentWillUnmount() {
    this.props.setSelectedModifiersAction({});
    this.props.setLastModifierSelectionAction({});
    this.props.setSelectedQtyAction(1);
    this.props.setAddOnModifiersAction({});
  }

  render() {
    const {
      history,
      location,
      breadcrumbs,
      productDetails,
      components,
      fetchReviewsAverageRatingAction,
      userDetails,
    } = this.props;

    const productDataReady = !!(productDetails && productDetails.gallery);

    if (!productDataReady) {
      return <LoadingContainer />;
    }

    return (
      <div className="pdp">
        <ProductAboveTheFoldContainer
          breadcrumbs={breadcrumbs}
          renderBreadcrumbs={renderBreadcrumbs}
        />
        <section className="pdp-btf">
          <ProductBelowFold
            components={components}
            userDetails={userDetails}
            productDetails={productDetails}
            history={history}
            location={location}
            fetchReviewsAverageRating={fetchReviewsAverageRatingAction}
          />
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  productDetails: getProductDetails(state),
  breadcrumbs: getProductBreadcrumbs(state),
  userDetails: getUserDetails(state),
});

const mapDispatchToProps = {
  setSelectedModifiersAction: setSelectedModifiers,
  setLastModifierSelectionAction: setLastModifierSelection,
  setSelectedQtyAction: setSelectedQty,
  setAddOnModifiersAction: setAddOnModifiers,
  fetchReviewsAverageRatingAction: fetchReviewsAverageRating,
};

export default compose(
  withRouter,
  withScrollingView(mapStateToProps, mapDispatchToProps),
)(Product);
